import { type FetchQueryFetchPolicy } from 'relay-runtime';

export type QueryInteropFetchPolicy =
	| 'cache-first'
	| 'cache-and-network'
	| 'network-only'
	| 'cache-only'
	| 'no-cache'
	| 'standby';

// Relay:  https://relay.dev/docs/guided-tour/reusing-cached-data/fetch-policies/
// Apollo: https://www.apollographql.com/docs/react/data/queries#supported-fetch-policies
export function mapFetchPolicyForQuery(
	fetchPolicy: QueryInteropFetchPolicy | undefined,
): FetchQueryFetchPolicy {
	switch (fetchPolicy) {
		case 'no-cache':
		case 'network-only':
		case 'cache-and-network':
			// Map to 'network-only' to preserve the mandatory network refetch.
			// The cached-data-first behaviour can't be expressed here.
			return 'network-only';
		case 'cache-first':
		case 'cache-only': // TODO: shim a true store-only read; defaults to 'store-or-network' for now
		case 'standby': // No direct Relay equivalent — defaults to 'store-or-network'
		default:
			return 'store-or-network';
	}
}
